import { Route, Routes } from "react-router-dom";

import Interrupt from "./components/Interrupt";
import LoadTest from "./components/LoadTest";
import Login from "./components/Login";
import Main from "./components/Main";
import NotFound from "./components/NotFound";
import PrivateRoute from "./components/PrivateRoute";
import PublicRoute from "./components/PublicRoute";
import WelcomeToOpenEnrollment from "./components/WelcomeToOpenEnrollment";

import { IS_DEVELOPMENT } from "./const/Environment";

const App = (): JSX.Element => {
    return (
        <Routes>
            <Route path="/" element={<PrivateRoute />}>
                <Route path="/" element={<Main />} />
            </Route>
            <Route path="/home" element={<PrivateRoute />}>
                <Route path="/home" element={<Main />} />
            </Route>
            <Route path="/guardian/dashboard" element={<PrivateRoute />}>
                <Route path="/guardian/dashboard" element={<Main />} />
            </Route>
            <Route path="/guardian/open-enrollment/welcome-to-open-enrollment" element={<PublicRoute />}>
                <Route
                    path="/guardian/open-enrollment/welcome-to-open-enrollment"
                    element={<WelcomeToOpenEnrollment />}
                />
            </Route>
            <Route path="/login-welcome" element={<Interrupt />} />
            <Route path="/notFound" element={<NotFound />} />
            {/* Development ONLY */}
            {IS_DEVELOPMENT && (
                <>
                    <Route path="/backdoor" element={<Login />} />
                    <Route path="/loadtest" element={<NotFound />} />
                    <Route path="/loadtest/:userName" element={<PrivateRoute />}>
                        <Route path="/loadtest/:userName" element={<LoadTest />} />
                    </Route>
                </>
            )}
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
};

export default App;
